import gql from "graphql-tag"

export default gql`
  mutation {
    stopImpersonating {
      success
    }
  }
`
